module.exports = __webpack_public_path__ + "static/andrew-8cc3d750813e63a59e7a233a890b059c.jpeg";